export const NavBarBGColors = {
  WHITE: 'white',
  TRANSPARENT: 'transparent',
};
